export enum ModalNotificationLevel {
	LEVEL_PENDING = 'LEVEL_PENDING',
	LEVEL_SUCCESS = 'LEVEL_SUCCESS',
	LEVEL_ERROR = 'LEVEL_ERROR'
}
